import React from "react";
import { Panel } from 'primereact/panel';
import ProWaitlistClient from "./ProWaitlistClient";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import _ from 'lodash'

const ProWaitlistState = ({state, performAction})=>{
    const {height} = useWindowDimensions()
    const waitlistStatusName = _.gt(state.waitlistClients.length, 0)?`${state.waitlistStatusName} (${state.waitlistClients.length})`:state.waitlistStatusName
    return (          
        <Panel id={`${state.waitlistStatusId}`} header={waitlistStatusName} style={{height:`${height-150}px`,width:'100%'}}>   
           {state.waitlistClients.map((data, index)=>{               
               return <ProWaitlistClient key={`${index}`} data={data} performAction={performAction}/>  

           })
           }           
        </Panel>   
    )

}

export default ProWaitlistState;